"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFavorite = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconFavorite = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m12 .217 3.397 8.109 8.603.71v.15l-6.504 5.6 2.018 8.555-7.513-4.563-7.514 4.563 2.019-8.556L0 9.185V9v.037l8.605-.711L12 .217Zm0 5.566-1.917 4.578-4.946.409 3.761 3.238-1.14 4.831 4.243-2.577 4.242 2.577-1.14-4.83 3.762-3.24-4.947-.408-1.917-4.578Z"
}));
exports.IconFavorite = IconFavorite;
//# sourceMappingURL=IconFavorite.js.map